export default __webpack_public_path__ + "static/gallery-5-50debad625ac1c4300dfd7506f9df980.jpg";